module.exports = __webpack_public_path__ + "static/img/chrome_img_3.8c3433c1.png";